import { BrowserOAuthClient } from '@atproto/oauth-client-browser'

const OAUTH_BASE_URL =
  typeof window !== 'undefined' ? window.location.origin : 'https://assembly.blacksky.community'
const OAUTH_CLIENT_NAME = "Blacksky People's Assembly"

export const ASSEMBLY_SERVICE_DID = 'did:web:assembly.blacksky.community'
export const CREATE_SESSION_METHOD = 'community.blacksky.assembly.createSession'

export const OAUTH_SCOPE = [
  'atproto',
  'transition:email',
  'rpc:app.bsky.actor.getProfile?aud=*',
  'rpc:community.blacksky.assembly.createSession?aud=*',
  'repo:community.blacksky.assembly.conversation',
  'repo:community.blacksky.assembly.statement',
  'repo:community.blacksky.assembly.vote'
].join(' ')

function isLoopback() {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host === '::1'
}

let oauthClient = null

function createOAuthClient() {
  if (isLoopback()) {
    const port = window.location.port ? `:${window.location.port}` : ''
    const redirectUri = `http://127.0.0.1${port}/`
    const clientId =
      `http://localhost` +
      `?redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&scope=${encodeURIComponent(OAUTH_SCOPE)}`

    return new BrowserOAuthClient({
      clientMetadata: {
        client_id: clientId,
        redirect_uris: [redirectUri],
        scope: OAUTH_SCOPE,
        token_endpoint_auth_method: 'none',
        response_types: ['code'],
        grant_types: ['authorization_code', 'refresh_token'],
        application_type: 'web',
        dpop_bound_access_tokens: true
      },
      handleResolver: 'https://bsky.social'
    })
  }

  return new BrowserOAuthClient({
    clientMetadata: {
      client_id: `${OAUTH_BASE_URL}/oauth-client-metadata.json`,
      client_name: OAUTH_CLIENT_NAME,
      client_uri: OAUTH_BASE_URL,
      redirect_uris: [`${OAUTH_BASE_URL}/`],
      scope: OAUTH_SCOPE,
      token_endpoint_auth_method: 'none',
      response_types: ['code'],
      grant_types: ['authorization_code', 'refresh_token'],
      application_type: 'web',
      dpop_bound_access_tokens: true
    },
    handleResolver: 'https://bsky.social'
  })
}

export function getOAuthClient() {
  if (!oauthClient) {
    oauthClient = createOAuthClient()
  }
  return oauthClient
}

const IDENTITY_KEY = 'atproto_identity'

export function setAtprotoIdentity(identity) {
  localStorage.setItem(IDENTITY_KEY, JSON.stringify(identity))
}

export function getAtprotoIdentity() {
  try {
    const raw = localStorage.getItem(IDENTITY_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function clearAtprotoIdentity() {
  localStorage.removeItem(IDENTITY_KEY)
}

export function isAdminTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return typeof payload.exp !== 'number' || payload.exp * 1000 < Date.now()
  } catch {
    return true
  }
}
